import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga';

import './verify_email.css';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import firebase from "../../firebase/FirebaseProvider";

/**
 * Verify Auth Code from Email Verification link is valid or not.
 * Shows Email Verified link with Login button if Email is Valid.
 * Else shows error message with resend link.
 */
class VerifyEmailSHandler extends Component {
    constructor(props) {
        super(props);
        this.verifyEmailOobeCode = this.verifyEmailOobeCode.bind(this);

        this.state = {
            isEmailVerified: false,
            isLinkedExpired: false
        };
    }

    
    componentDidMount() {
        const query = new URLSearchParams(window.location.search);
        this.actionCode = query.get('oobCode');
        this.verifyEmailOobeCode(this.actionCode)
    }

    verifyEmailOobeCode(actionCode) {
        if (actionCode) {
            firebase.auth().applyActionCode(actionCode).then((resp) => {
                this.setState({ isEmailVerified: true });
                firebase.auth().signOut().then(function () {
                    console.log("User signed out");
                  }, function () {
                    console.log("Error logging out");
                  });
            }).catch((error) => {
                console.error("Error in handling password reset:", error)
                this.setState({ isLinkedExpired: true });
                const errorMsg = JSON.stringify(error);
                ReactGA.event({
                    category: 'Login',
                    action: 'Verify Email Error',
                    label: errorMsg
                });
            });
        } else {
            this.setState({ isLinkedExpired: true })
        }
    }

    render() {
        ReactGA.pageview('/verify-email-handler');
        const { user } = this.props;
        console.log("user:", user)
        return (
            <div className="email-body" >
                {/*
                <img src="/images/logo.png"
                    alt="logo"
                    className="image" />
                */}

                {(this.state.isEmailVerified) && <h1 className="signup_title"> Email Verification Successful. </h1>}
                {(this.state.isLinkedExpired) && <div>Link is expired and no longer valid. Email Verification Failed.</div>}
                {<h1 className="signup_title"> Please <Link to='/login'>Login</Link> </h1>}
            </div>
        );
    }
}

VerifyEmailSHandler.propTypes = {
    user: PropTypes.object
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    };
};

const mapDispatchToProps = dispatch => {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmailSHandler);